import ShimmerSeparator from "./Separator";
export default ShimmerSeparator;
